
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import * as echarts from 'echarts'
import store from './store/index';
Vue.prototype.$echarts = echarts  //注册echarts
Vue.prototype.$http = axios  //注册axios插件
Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')